import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../App.vue"),
    children: [
      {
        path: "/",
        name: "PcHome",
        // component: EventDetail,
        component: (resolve) =>
          require(["@/views/pc/EventDetail.vue"], resolve),
        meta: {
          title: "专题站",
        },
      },
      {
        path: "pc",
        name: "PcIndex",
        // component: EventDetail,
        component: (resolve) =>
          require(["@/views/pc/EventDetail.vue"], resolve),
        meta: {
          title: "专题站",
        },
      },
      {
        path: "pcNew",
        name: "PcIndex",
        // component: EventDetail,
        component: (resolve) =>
          require(["@/views/pc/EventDetailNew.vue"], resolve),
        meta: {
          title: "专题站",
        },
      },
      {
        path: "wap",
        name: "WapIndex",
        // component: ActivityDetail,
        component: (resolve) =>
          require(["@/views/wap/ActivityDetail.vue"], resolve),
        meta: {
          title: "专题站",
        },
      },
      {
        path: "wapNew",
        name: "WapIndexNew",
        // component: ActivityDetail,
        component: (resolve) =>
          require(["@/views/wap/ActivityDetailNew.vue"], resolve),
        meta: {
          title: "专题站",
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
